import axios from 'axios'
var Coupon = {};

Coupon.install = function(Vue) {
  Vue.prototype.$coupon = {
    checkCoupon(couponCode, amount, callback, errorCallback) {
      axios({
        method: 'GET',
        url: `${process.env.VUE_APP_AUTH_API}/coupons/check`,
        params: { couponCode, amount },
      }).then((response) => callback(response.data.data)).catch((error) => errorCallback(error.response.data));
    }
  }
}

export default Coupon;
